import { Component } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  standalone: false,
})
export class ErrorPageComponent {
  constructor() {
    //this is a component
  }
}
